// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowThinDown: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="4" viewBox="0 0 9 4" fill="currentColor">
            <path
                d="M678.125775,1039.63402 L674.396869,1042.90678 C674.253314,1043.03107 674.038041,1043.03107 673.894369,1042.90678 L670.123978,1039.63402 C669.970228,1039.47947 669.957807,1039.27038 670.096088,1039.12038 C670.243275,1038.96356 670.480462,1038.96583 670.626478,1039.09311 L674.124994,1042.14768 L677.624212,1039.09311 C677.778759,1038.95954 678.015384,1038.97126 678.154368,1039.12011 C678.292181,1039.27038 678.280462,1039.47947 678.125775,1039.63402 Z"
                transform="translate(-670 -1039)"
            />
        </svg>
    );
};

export default React.memo(IconArrowThinDown);
